import Vuex from 'vuex';

//initial state
const state = {
  listPagePars: new Map(), //查询页的查询条件
};

// 同步操作
const mutations = {
  SAVE_LIST_PAGE_PARS: (state, { path, pars }) => {
    state.listPagePars.set(path, pars);
  },
  RESET_LIST_PAGE_PERS: (state) => {
    state.listPagePars = new Map();
  }
};
const actions = {
  saveListPagePars: ({ commit }, { path, pars }) => {
    commit('SAVE_LIST_PAGE_PARS', { path, pars });
  }
}
const Store = () => {
  return new Vuex.Store({
    state,
    mutations,
    actions
  });
};

export default Store;



// WEBPACK FOOTER //
// ./src/store/store.js